import { useEffect, useRef } from "react";
import * as signalR from "@microsoft/signalr";
import { useDispatch, useSelector } from "react-redux";
import configs from "../../configs/config";

const TicketUrl =configs.TICKET_HUB_URL;
export function useTicketRefreshService() {
  const dispatch = useDispatch();
  const currAgent = useSelector(
    (state: any) => state?.agentReducer?.loggedInAgent
  );

  // The handler reads the agent via this ref instead of being a useEffect
  // dependency, so the connection below doesn't get torn down and rebuilt
  // every time the logged-in agent changes (e.g. right after login, when
  // currAgent populates asynchronously) - restarting mid-negotiate is what
  // caused "The connection was stopped during negotiation" errors.
  const currAgentRef = useRef(currAgent);
  useEffect(() => {
    currAgentRef.current = currAgent;
  }, [currAgent]);

  useEffect(() => {
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${TicketUrl}/tickethub`, {
        transport:
          signalR.HttpTransportType.WebSockets |
          signalR.HttpTransportType.LongPolling,
      })
      .withAutomaticReconnect()
      .build();

    const handleNewTicketRemove = (data: any) => {
      const tenantCode = localStorage.getItem("tenantCode");
      const myCurrAgent = currAgentRef.current;
      if (
        tenantCode &&
        data?.tenantCode === tenantCode &&
        myCurrAgent?.id === data?.data?.ownerId
      ) {
        dispatch({ type: "DROPPED_TO_NEWTOME", payload: data?.ticketId });
      } else {
        dispatch({ type: "REMOVED_NEWTICKET", payload: data?.ticketId });
      }
    };

    // Register handlers before starting the connection [6]
    connection.on("NewTicketRemoved", handleNewTicketRemove);

    connection
      .start()
      .catch((err) => {
        console.error("SignalR connection error:", err);
      });

    connection.onclose((error) => {
      console.warn("SignalR connection closed", error);
    });

    return () => {
      connection.off("NewTicketRemoved", handleNewTicketRemove);
      connection.stop();
    };
  }, [dispatch]);

  // No return value needed for this hook
}
